import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import CategoryManager from "./CategoryManager"
import ClassifyTab from "./ClassifyTab"
import { useTaxonomyWithDatabase } from "./CategoryManager/hooks/useTaxonomyWithDatabase"

const NodesTab = () => {
  const { initialData, operations, loading, operationInProgress, reload } =
    useTaxonomyWithDatabase()

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full bg-admin_canvas">
        <div className="flex items-center gap-2 text-admin_text_dim text-sm">
          <span className="w-4 h-4 border-2 border-admin_primary border-t-transparent rounded-full animate-spin" />
          Loading taxonomy...
        </div>
      </div>
    )
  }

  if (!initialData) return null

  return (
    <CategoryManager
      initialData={initialData}
      operations={operations}
      operationInProgress={operationInProgress}
      onReload={reload}
    />
  )
}


export default function TaxonomyAdmin() {
  return (
    <SidePanelLayout
      menuName="AdminTaxonomyMenu"
      tabs={{
        nodes: NodesTab,
        classify: ClassifyTab,
      }}
    />
  )
}
